/**
 * Dictionary loader for gt-react. Called once per locale change. We
 * keep dictionaries co-located with the app (not in the shared
 * packages/shared/src/i18n/translations/) so marketing strings don't
 * bloat the ERP bundle and vice versa.
 */
export default async function loadDictionary(locale: string) {
  const t = await import(`../dictionaries/${locale}.json`)
  return t.default
}
